<template>
  <div>
    <h4 class="mt-4 font-weight-bold text-secondary">
      <i class="fas fa-file-invoice-dollar"></i> แจ้งถอนรายได้
    </h4>
    <b-alert variant="primary" class="text-center mt-3" show>รายได้ ระบบแนะนำ จะถอนเข้าเป็นเงินเครดิต หากสงสัยโปรดติดต่อเอเย่นต์ที่ท่านสมัครสมาชิก</b-alert>
    <p class="text-secondary font-weight-bold text-center mb-0">รายได้ปัจจุบัน - คงเหลือ</p>
    <h3 class="thb text-primary font-weight-bold text-center">฿ {{totalBalance.toLocaleString()}}</h3>
    <b-input-group>
        <template #prepend>
        <b-input-group-text>ต้องการถอน</b-input-group-text>
        </template>
        <b-input placeholder="ระบุจำนวนเงิน" type="number" :max="totalBalance" v-model="withdrawAmount"></b-input>
    </b-input-group>

    <b-btn type="submit" class="btn golden-btn btn-block mb-2 mt-2" @click="submitWithdraw">
      <i class="fas fa-hand-holding-usd"></i>
      แจ้งถอนรายได้
    </b-btn>

    <h4 class="mt-4 font-weight-bold text-secondary">
      <i class="fas fa-history"></i> ประวัติการถอนล่าสุด
    </h4>
    <b-table striped hover :items="withdraws" :fields="field" small responsive show-empty emptyText="ไม่มีรายการ"
      id="my-table"
      :per-page="perPage"
      :current-page="currentPage">
      <template #cell(withdrawAmount)="data">
        <span>{{data.item.withdrawAmount.toLocaleString()}}</span>
      </template>
      <template #cell(balance)="data">
        <span>{{data.item.balance.toLocaleString()}}</span>
      </template>
    </b-table>
    <div class="overflow-auto">
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "Withdraw",
  data() {
    return {
      totalBalance:0,
      withdrawAmount: 0,
      field: [
        {
          key: 'withdrawDate',
          label: 'วัน - เวลาที่ถอน',
        },
        {
          key: 'withdrawAmount',
          label: 'จำนวนที่ถอน',
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        {
          key: 'balance',
          label: 'คงเหลือ',
          thClass: 'text-right',
          tdClass: 'text-right'
        }
      ],
      perPage: 10,
      currentPage: 1,
      withdraws: [
      ]
    };
  },
  mounted() {
    this.getResult();
  },     
  methods: {
    getResult() {
      axios.post(this.getApiUrl + "/affiliate/withdraw",
        {
          CustomerCode: this.getUsername,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "token": this.getAccessToken,
            "username": this.getUsername
          }
        })
        .then(response => {
          this.totalBalance = response.data.data.balance;
          this.withdraws = response.data.data.transaction;
          console.log('withdraws', this.withdraws);
        });
    },
    submitWithdraw() {
      axios
        .post(
          this.getApiUrl + "/affiliate/withdraw/add",
          {
            amount: this.withdrawAmount,
            username: this.getUsername
          },
          {
            headers: {
              "Content-Type": "application/json",
              token: this.getAccessToken,
              username: this.getUsername
            }
          }
        )
        .then(response => {
          if (response.data.statusCode == 200) {
            console.log(response.data.data);
            if(response.data.data.Status == true)
            {
              this.getResult();
              this.$bvToast.toast("ส่งข้อมูลสำเร็จแล้ว", {
                title: "แจ้งถอนรายได้",
                variant: "success",
                solid: true,
                appendToast: true
              });
            }else{
              this.$bvToast.toast(response.data.data.Msg, {
                title: "แจ้งถอนรายได้",
                variant: "danger",
                solid: true,
                appendToast: true
              });
            }
          }else{
            this.$bvToast.toast("ส่งข้อมูลผิดพลาด", {
              title: "แจ้งถอนรายได้",
              variant: "danger",
              solid: true,
              appendToast: true
            });
          }
          console.log(response);
        });
    },        
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getApiUrl: "getApiUrl"
    }),    
    rows() {
      return this.withdraws.length;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>